import React, { Component } from 'react';
import './education.css';
import Navbar from '../layouts/navbar';
import { Link } from 'react-router-dom';
// import vendiagram from "../../assets/img/vennDiagram.jpeg";

class Education extends Component {

    render() {

        const style = {
            width: '50%'
        };
        const style1 = {
            height: '20vh',
            width: '100%',
        }

        return (
            // <div>
            //     <Navbar head="Education" />
            //     {/* <Ellipse /> */}
            //     <div className='container'>
            //         {/* <img src={vendiagram} className='vennDiagram' /> */}
            //     </div>
            //     <div className="container">

            //         <div className="cards container">
            //             <div className="row">

        <div>
            <Navbar head="Education"/>
            <div className="container" style={{marginTop:"50px"}}>
                
                <div className="cards container">
                    <div className="row">
        
                        <div className="col-lg-4 col-sm-6 col-xs-6 mt-3" style={style}>
                            <Link to="/education/marijuana">
                            <div className="card cd marijuana" style={style1}>
                                {/* <div className="card-body">
                                <h5 className="card-title title">Applied maths-4</h5>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Cannabis</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/cigerate">
                                    <div className="card cd cigerate" style={style1}>
                                        {/* <div className="card-body">
                                <h5 className="card-title title">Applied maths-4</h5>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Cigarette</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/cocaine">
                                    <div className="card cd cocaine" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Cocaine</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/alcohol">
                                    <div className="card cd alcohol" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Alcohol</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/meth">
                                    <div className="card cd hashish" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Methamphetamine</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/heroine">
                                    <div className="card cd heroine" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Heroin</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/Ameth">
                                    <div className="card cd amphetamine" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Amphetamine</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/mdma">
                                    <div className="card cd mdma" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">MDMA</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/lsd">
                                    <div className="card cd lsd" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">LSD</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/pcp">
                                    <div className="card cd pcp" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">PCP</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/opioids">
                                    <div className="card cd opioids" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Prescription Opioids</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-6 mt-3 " style={style}>
                                <Link to="/education/depressants">
                                    <div className="card cd depressants" style={style1}>
                                        {/* <div className="card-body">
                                <p className="card-title title">Applied maths-4</p>
                                <h6 className="card-subtitle title mb-2 text-muted">Dr. Mukta Garg </h6>
                                <p className="card-text"><strong>Room : </strong>A block • 2nd floor</p> */}
                                        <p className="card-title title">Prescription Depressants</p>
                                        {/* </div> */}
                                    </div>
                                </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Education;